import { squareBlockCSS } from '@braskai/ui-kit';

import { css, Stack, styled } from '@mui/material';

import { Avatar } from '@/shared/ui/Avatar';

export const SContainer = styled(Stack)(
  ({ theme }) => css`
    background-color: ${theme.palette.grey[50]};
    padding: 16px;
    border-radius: 10px;
  `,
);

export const SContent = styled(Stack)(
  ({ theme }) => css`
    height: 88px;

    ${theme.breakpoints.up('desktop')} {
      height: 45px;
    }
  `,
);

export const SAvatar = styled(Avatar)(
  () => css`
    ${squareBlockCSS(32)};
  `,
);

export const SStarsContainer = styled(Stack)(
  () => css`
    width: 76px;
    flex-direction: row;
    align-items: center;
    margin-left: auto;
    gap: 4px;
  `,
);

export const SQuoteContainer = styled(Stack)(
  () => css`
    > * {
      width: 50%;
    }
  `,
);

export const SImage = styled('img')(
  () => css`
    max-width: 100%;
    width: 100%;
  `,
);
